<template>
   <div v-if="isAddModalShown">
      <div class="modal-mask" role="dialog">
         <div class="overlay-mask">
            <div class="modal-dialog modal-lg">
               <div class="modal-content modal-edit-bg">
                  <div class="modal-body">
                     <div class="close_btn" v-on:click="CloseModal()"></div>
                     <br>
                     <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
                           <div class="my-account-title">Add Eye Doctor Information</div>
                           <div class="account_section_box">
                              <div class="row">
                                 <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <label class="account_label">NPI Number:</label>
                                 </div>
                                 <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                    <div class="form-group">
                                       <label>NPI Number
                                       <span v-if="!NewDoctor.useLicenseNumber">*</span>
                                       <span v-bind:data-balloon="npiTooltip" data-balloon-pos="down" data-balloon-length="large">
                                       <i class="fa fa-question-circle-o"></i>
                                       </span>
                                       </label>
                                       <input type="text" maxlength="10" class="form-control input_field"
                                          v-on:paste="pasteNpiNumber($event)"
                                          v-on:keypress="G_NumberCheck(this.event);" v-model="NewDoctor.npiNumber"  v-on:keyup="ValidateNpiNumberEyeDoctor()"
                                          v-bind:class="{ error_field: NewDoctorValidationResult.EyeDoctorNpiNumber }">
                                       <p class="error-message" v-if="NewDoctorValidationResult.EyeDoctorNpiNumber">{{NewDoctorValidationResult.EyeDoctorNpiNumber}}</p>
                                       <p class="error-message" v-if="invalidNpiNumberPaste">Sorry, only numeric NPI values can be pasted here.</p>
                                    </div>

                                    <div class="row">
                                       <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                          <div class="form-check">
                                             <input  value=""  type="checkbox" class="form-check-input" v-model="NewDoctor.useLicenseNumber">
                                             <label>Use License Number</label>
                                          </div>
                                       </div>
                                    </div>
                                    <div class="form-group">
                                          <label>Relationship*
                                             <span v-bind:data-balloon="relationshipTooltip" data-balloon-pos="down" data-balloon-length="large">
                                                <i class="fa fa-question-circle-o"></i>
                                             </span>
                                          </label>
                                          <select v-bind:class="{ error_field: NewDoctorValidationResult.EyeDoctorRole }"  v-model="NewDoctor.Role" class="form-control">
                                             <!-- <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option> -->
                                             <option>Self</option>
                                             <option>Employee</option>
                                             <option>Contractor</option>
                                             <option>Unaffiliated</option>
                                             <option>Other</option>
                                          </select>
                                          <!-- <input type="text" maxlength="10" v-model="Account.Role" v-bind:class="{ error_field: EyeDoctorValidation.Role }" class="form-control"> -->
                                          <p class="error-message" v-if="NewDoctorValidationResult.EyeDoctorRole">{{NewDoctorValidationResult.EyeDoctorRole}}</p>
                                    </div>

                                 </div>
                              </div>
                              <div class="row">
                                 <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <label class="account_label">Name: </label>
                                 </div>
                                 <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                    <div class="row">
                                       <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                          <div class="form-group">
                                             <label>Doctor's First Name*</label>
                                             <input type="text" class="form-control input_field capitalize" v-model="NewDoctor.firstName"
                                                v-bind:class="{ error_field: NewDoctorValidationResult.EyeDoctorFirstName }">
                                             <p class="error-message" v-if="NewDoctorValidationResult.EyeDoctorFirstName">{{NewDoctorValidationResult.EyeDoctorFirstName}}</p>
                                          </div>
                                       </div>
                                       <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                          <div class="form-group">
                                             <label>Doctor's Last Name*</label>
                                             <input  type="text" class="form-control input_field capitalize" v-model="NewDoctor.lastName"
                                                v-bind:class="{ error_field: NewDoctorValidationResult.EyeDoctorLastName }">
                                             <p class="error-message" v-if="NewDoctorValidationResult.EyeDoctorLastName">{{NewDoctorValidationResult.EyeDoctorLastName}}</p>
                                          </div>
                                       </div>
                                       <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                          <div class="form-group">
                                             <label>Suffix*</label>
                                             <select class="form-control select_field" v-model="NewDoctor.suffix" v-bind:class="{ error_field: NewDoctorValidationResult.EyeDoctorSuffix }">
                                                <option v-for="(value, key) in Suffix" v-bind:value="key">{{key}}</option>
                                             </select>
                                             <p class="error-message" v-if="NewDoctorValidationResult.EyeDoctorSuffix">{{NewDoctorValidationResult.EyeDoctorSuffix}}</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div class="row" v-if="NewDoctor.useLicenseNumber">
                                 <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <label class="account_label">License Number/State:</label>
                                 </div>
                                 <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                    <div class="row">
                                       <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                          <div class="form-group">
                                             <label>License Number *</label>
                                             <input type="text" class="form-control input_field" v-model="NewDoctor.licenseNumber" maxlength="18"
                                                v-bind:class="{ error_field: NewDoctorValidationResult.EyeDoctorLicenseNumber }">
                                             <p class="error-message" v-if="NewDoctorValidationResult.EyeDoctorLicenseNumber">{{NewDoctorValidationResult.EyeDoctorLicenseNumber}}</p>
                                          </div>
                                       </div>
                                       <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                          <div class="form-group">
                                             <label>State *</label>
                                             <select class="form-control select_field" v-model="NewDoctor.state" v-bind:class="{ error_field: NewDoctorValidationResult.EyeDoctorState }">
                                                <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option>
                                             </select>
                                             <p class="error-message" v-if="NewDoctorValidationResult.EyeDoctorState">{{NewDoctorValidationResult.EyeDoctorState}}</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div class="row">
                                 <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <label class="account_label">Year Licensed:</label>
                                 </div>
                                 <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                    <div class="form-group">
                                       <label>Year Licensed</label>
                                       <div class="row">
                                          <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                             <input v-on:keypress="G_NumberCheck(this.event)"
                                                v-on:keyup="G_NumberOfYearsCheck(NewDoctor, 'yearsInPractice')"
                                                v-on:blur="CheckYearLicense(NewDoctor.yearsInPractice)"
                                                type="number" class="form-control input_field" min="1" v-model="NewDoctor.yearsInPractice">
                                          </div>
                                       <p class="error-message" v-if="NewDoctorValidationResult.EyeDoctorYearsInPractice">{{NewDoctorValidationResult.EyeDoctorYearsInPractice}}</p>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div class="row">
                                 <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <label class="account_label">Doctor's Email Address:</label>
                                 </div>
                                 <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                    <div class="form-group">
                                       <label>Doctor's Email Address*</label>
                                       <input class="form-control input_field" v-model="NewDoctor.emailAddress"
                                          v-bind:class="{ error_field: NewDoctorValidationResult.EyeDoctorEmailAddress }"
                                          name="email" type="email" v-validate="'email'" data-vv-as="email" oninput="this.value = this.value.toLowerCase()">
                                       <p class="error-message" v-show="errors.has('email') && !NewDoctorValidationResult.EyeDoctorEmailAddress">{{ errors.first('email') }}</p>
                                       <p class="error-message" v-if="NewDoctorValidationResult.EyeDoctorEmailAddress">{{NewDoctorValidationResult.EyeDoctorEmailAddress}}</p>
                                    </div>
                                 </div>
                              </div>
                              <div class="row">
                                 <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <label class="account_label">Professional Associations:</label>
                                 </div>
                                 <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                    <div class="form-group">
                                       <div v-for="(value, key) in CheckboxIndividual" class="form-check">
                                          <p class="form-check-label">
                                             <input :value="key" v-model="NewDoctor.organizations.list" class="form-check-input" type="checkbox">
                                             {{key}}
                                          </p>
                                       </div>
                                       <div class="form-group" v-if="NewDoctor.organizations.list.indexOf('Other') >= 0">
                                          <p>Please enter any other professional organizations you are associated with separated by semicolon(;).</p>
                                          <input type="text" v-model="NewDoctor.organizations.others" class="form-control input_field">
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                           <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-mx-10 g-my-10 g-font-size-17 g-px-40" v-on:click="AddThisDoctor()">Add This Doctor</button>
                           <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-mx-10 g-my-10 g-font-size-17 g-px-40" v-on:click="CloseModal()">Cancel</button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
export default {
  props: [
    "AccountView",
    "AccountEdit",
    "FormInputs",
    "Suffix",
    "State",
    'CheckboxIndividual',
    'isFormLoading',
    'eyeDoctorActive',
    'eyeDoctorActiveIndex',
    'EyeDoctorValidation',
    'NewDoctor',
    'NewDoctorValidationResult'
  ],
  components: {},
  data() {
    return {
      isValid: true,
      isAddModalShown: true,
      errorMessage: {
          year: null
      },
      invalidNpiNumberPaste: false,
    };
  },
  methods: {
    pasteNpiNumber(event) {
      var re = /^\d+$/;
      if (!re.test(event.clipboardData.getData('text'))) {
        this.invalidNpiNumberPaste = true;
      } else {
        this.invalidNpiNumberPaste = false;
      }
    },
    CloseModal() {
      this.isAddModalShown = false;
      this.$emit("modalClose");
      document.body.classList.remove("body-overflow");
    },
    AddThisDoctor(){
      let npiLength = 0
      if(this.NewDoctor && this.NewDoctor.npiNumber){
         npiLength = this.NewDoctor.npiNumber.length
      }
      if(this.NewDoctor.useLicenseNumber == false){
         if(npiLength != 10){
            this.NewDoctorValidationResult.EyeDoctorNpiNumber = "Invalid NPI Number"
            this.isValid = false;
         } else {
            if(this.NewDoctorValidationResult.EyeDoctorNpiNumber == null){
               this.isValid = true;
            }
         }
      } else {
         this.isValid = true;
      }

       if(this.isValid){
          this.$emit("AddEyeDoctor");
      } else {
          alert("Please make sure all required fields are complete.")
      }
    },
    ValidateNpiNumberEyeDoctor() {
      let npiLength = 0
      if(this.NewDoctor && this.NewDoctor.npiNumber){
         npiLength = this.NewDoctor.npiNumber.length
      }


      if(npiLength != 10){
         this.NewDoctorValidationResult.EyeDoctorNpiNumber = "Invalid NPI Number"
         this.isValid = false;
      }



      this.$emit("npiIsDirty");
    },
    CheckYearLicense(yearPractice) {
        var year = yearPractice;
        var result = this.G_CheckYearLicense(year);
        if(result)
            this.errorMessage.year = result;
        else
            this.errorMessage.year = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// AddDoctor.vue?063eacad